import { useCallback, useEffect, useMemo, useState } from 'react'

import { HomePageProps } from './HomePage'
import { checkAvaiableSpotlight } from '../spotlight/utils'

export function useHomeSpotlights(props: Pick<HomePageProps, 'spotlights'>) {
  const { spotlights: spotlightsProps } = props

  const spotlights = useMemo(
    () => spotlightsProps.filter(checkAvaiableSpotlight),
    [spotlightsProps],
  )

  return useMemo(() => ({ spotlights }), [spotlights])
}

export function useHomeShowAsideNavigator(
  el: HTMLDivElement | null,
  isMobile?: boolean,
) {
  const [showAsideNavigator, setShowAsideNavigator] = useState<boolean>(false)

  const handleScroll = useCallback(() => {
    if (!el) {
      return
    }
    if (window.scrollY > el.offsetTop + 64) {
      setShowAsideNavigator(true)
      document.body.classList.remove('collapse-sticky-bar')
    } else {
      setShowAsideNavigator(false)
      document.body.classList.add('collapse-sticky-bar')
    }
  }, [isMobile])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    document.body.classList.add('homepage')
    return () => {
      window.removeEventListener('scroll', handleScroll)
      document.body.classList.remove('homepage')
      document.body.classList.remove('collapse-sticky-bar')
    }
  }, [])

  return useMemo(() => ({ showAsideNavigator, setShowAsideNavigator }), [
    showAsideNavigator,
  ])
}
